/*
 * @Author: Haotian Zheng
 * @Date: 2023-07-28 18:37:16
 * @Descripttion:
 * @LastEditors: Haotian Zheng
 * @LastEditTime: 2023-07-31 20:26:03
 */
import axios from './http'
import base from './base'

//获取当前用户的菜单列表
export function getMenuList(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/resource/getCurrentMenuList`,
    method: 'get',
    params,
  })
}

//获取当前用户的按钮列表
export function getCurrentBtnList(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/resource/getCurrentBtnList`,
    method: 'get',
    params,
  })
}

// 查询是否已购买小福智融、好会计、易代账、代理商
export function getAppIsOpenByTenantId(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/tenantApp/getAppIsOpenByTenantId`,
    method: 'get',
    params,
  })
}
